import _construct from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CRUTransportLayer } from '../CRUTransportLayer';
import { ProductInfoFilterConverterImpl, ProductConverter, jsonConversions, DataPairingProductRowDTOConverter, ProductSuppliersGroupConverter, FamilyBindingConverter, FindWindowProductsDTOConverter, ResultWithOverviewConverterImpl, ValidationError } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import { List } from 'immutable';
import logger from '../../logger';
export var ProductLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(ProductLayer, _CRUTransportLayer);

  function ProductLayer() {
    _classCallCheck(this, ProductLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductLayer).call(this, CONSTANTS.API.ENDPOINTS.PRODUCTS));
  }

  _createClass(ProductLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Filter products base on filter params
     * @param productIds
     */

  }, {
    key: "filter",
    value: function filter(productIds) {
      var _this = this;

      return api("".concat(CONSTANTS.API.ENDPOINTS.PRODUCTS_FILTER)).post({
        ids: productIds,
        activeUnaware: true
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
    }
    /**
     * Finds all products in specific category
     * @param categoryId id of requested category
     */

  }, {
    key: "findInCategory",
    value: function findInCategory(categoryId) {
      var _this2 = this;

      var findInCategoryPromise = api(CONSTANTS.API.ENDPOINTS.PRODUCTS_IN_CATEGORY(categoryId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this2.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return findInCategoryPromise;
    }
    /**
     * Finds purchase prices for all products in specific category
     * @param categoryId id of requested category
     */

  }, {
    key: "findPurchasePriceInCategory",
    value: function findPurchasePriceInCategory(categoryId) {
      var findInCategoryPromise = api(CONSTANTS.API.ENDPOINTS.PURCHASE_PRICE_IN_CATEGORY(categoryId)).get({
        responseType: 'json'
      }).then(function (response) {
        return response.data.result || [];
      });
      return findInCategoryPromise;
    }
  }, {
    key: "updateTier",
    value: function updateTier(updates) {
      var _this3 = this;

      var updateTierPromise = api(CONSTANTS.API.ENDPOINTS.PRODUCTS_UPDATE_TIER).post({
        updates: updates
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this3.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return updateTierPromise;
    }
  }, {
    key: "updateSensitivity",
    value: function updateSensitivity(updates) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_UPDATE_SENSITIVITY).post({
        updates: updates
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this4.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
    }
  }, {
    key: "assignToFamily",
    value: function assignToFamily(familyId, bindings) {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.FAMILY_ASSIGN_PRODUCTS(familyId)).post({
        bindings: bindings.map(function (b) {
          return _this5.familyBindingConverter.toDocument(b, jsonConversions);
        })
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this5.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
    } // FIXME: Data any

  }, {
    key: "getProductsFullTextSearch",
    value: function getProductsFullTextSearch(overview) {
      var resultWithOverviewConverter = new ResultWithOverviewConverterImpl(this.productDTOConverter, new ProductInfoFilterConverterImpl());
      return api("".concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.FULL_TEXT_SEARCH)).post({
        overview: overview
      }, {
        responseType: 'json'
      }).then(function (response) {
        return resultWithOverviewConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "findUnits",
    value: function findUnits() {
      return api(CONSTANTS.API.ENDPOINTS.UNITS).get({
        responseType: 'json'
      }).then(function (response) {
        return response.data.result || [];
      });
    }
  }, {
    key: "findByFilter",
    value: function findByFilter(filter) {
      var _this6 = this;

      return api("".concat(CONSTANTS.API.ENDPOINTS.PRODUCTS_FILTER)).post(filter, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this6.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
    }
  }, {
    key: "approvePriceSettings",
    value: function approvePriceSettings(id) {
      var _this7 = this;

      var approvePriceSettingsPromise = api(CONSTANTS.API.ENDPOINTS.PRODUCTS_APPROVE_PRICE_SETTINGS(id)).put({
        responseType: 'json'
      }).then(function (response) {
        return _this7.getConverter().toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return approvePriceSettingsPromise;
    }
  }, {
    key: "setLeader",
    value: function setLeader(id) {
      var _this8 = this;

      var setLeaderPromise = api(CONSTANTS.API.ENDPOINTS.PRODUCTS_SET_LEADER(id)).post({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this8.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return setLeaderPromise;
    }
  }, {
    key: "findSuppliers",
    value: function findSuppliers(productIds) {
      var _this9 = this;

      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_SUPPLIERS).post({
        productIds: productIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (i) {
          return _this9.productSuppliersGroupConverter.toObject(i, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Find window products based on filter
     * @param params
     */

  }, {
    key: "findWindowProducts",
    value: function findWindowProducts(params) {
      var _this10 = this;

      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_WINDOW).post(params, {
        responseType: 'json'
      }).then(function (response) {
        return _this10.findWindowProductsDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Find window products based on categoryId
     * @param categoryId
     */

  }, {
    key: "findWindowProductsByCategoryId",
    value: function findWindowProductsByCategoryId(categoryId) {
      var _this11 = this;

      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_WINDOW_BY_CATEGORY(categoryId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this11.findWindowProductsDTOConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "priceArchitectureExport",
    value: function priceArchitectureExport() {
      return api(CONSTANTS.API.ENDPOINTS.EXPORT_PRICE_ARCHITECTURE).post({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "dataCleaningExport",
    value: function dataCleaningExport() {
      return api(CONSTANTS.API.ENDPOINTS.EXPORT_DATA_CLEANING).post({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "dataPairingExport",
    value: function dataPairingExport() {
      return api(CONSTANTS.API.ENDPOINTS.EXPORT_DATA_PAIRING).post({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "releaseDetailExport",
    value: function releaseDetailExport(releaseId) {
      return api(CONSTANTS.API.ENDPOINTS.EXPORT_RELEASE_DETAIL(releaseId)).post({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "releaseSelloutDetailExport",
    value: function releaseSelloutDetailExport(releaseId) {
      return api(CONSTANTS.API.ENDPOINTS.EXPORT_RELEASE_SELLOUT_DETAIL(releaseId)).post({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "siteReleaseDetailExport",
    value: function siteReleaseDetailExport(releaseId) {
      return api(CONSTANTS.API.ENDPOINTS.EXPORT_SITE_RELEASE_DETAIL(releaseId)).post({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "validateByExternalIds",
    value: function validateByExternalIds(externalIds, filter) {
      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_VALIDATE_BY_EXTERNAL_IDS).post({
        externalIds: externalIds.toArray(),
        filter: filter
      }, {
        responseType: 'json'
      }).then(function (response) {
        return List(response.data.validationErrors.map(function (err) {
          return _construct(ValidationError, [err.messageKey].concat(_toConsumableArray(err.messageArgs)));
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return ProductLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", ProductConverter)], ProductLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", DataPairingProductRowDTOConverter)], ProductLayer.prototype, "productDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ProductSuppliersGroupConverter)], ProductLayer.prototype, "productSuppliersGroupConverter", void 0);

__decorate([Inject, __metadata("design:type", FamilyBindingConverter)], ProductLayer.prototype, "familyBindingConverter", void 0);

__decorate([Inject, __metadata("design:type", FindWindowProductsDTOConverter)], ProductLayer.prototype, "findWindowProductsDTOConverter", void 0);